import { render, staticRenderFns } from "./PartiallyDenied.vue?vue&type=template&id=d15dfb4c&scoped=true"
import script from "./PartiallyDenied.vue?vue&type=script&lang=js"
export * from "./PartiallyDenied.vue?vue&type=script&lang=js"
import style0 from "./PartiallyDenied.vue?vue&type=style&index=0&id=d15dfb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15dfb4c",
  null
  
)

/* custom blocks */
import block0 from "./PartiallyDenied.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports